import React, { useState, useEffect } from "react";
import { AppProvider, useApp } from "./context/AppContext";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Login from "./components/auth/Login";
import Sidebar from "./components/layout/Sidebar";
import Topbar from "./components/layout/Topbar";
import Dashboard from "./components/dashboard/Dashboard";
import Expenses from "./components/expenses/Expenses";
import Team from "./components/team/Team";
import LivePrices from "./components/crypto/LivePrices";
import Portfolio from "./components/crypto/Portfolio";
import AuditLog from "./components/audit/AuditLog";
import Loans from "./components/loans/Loans";
import Payroll from "./components/payroll/Payroll";
import Invoice from "./components/invoice/Invoice";
import Payslip from "./components/payslip/Payslip";
import Attendance from "./components/attendance/Attendance";
import Security from "./components/security/Security";
import Backup from "./components/backup/Backup";
import AnalyticsReports from "./pages/AnalyticsReports";
import "./index.css";

function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  return <div className={"toast toast-" + toast.type}>{toast.message}</div>;
}

function AppContent() {
  const { mode, isLoading } = useApp();
  const [activePage, setActivePage] = useState("dashboard");
  const [mobile, setMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const h = () => setMobile(window.innerWidth <= 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  if (isLoading) return <div className="loading-screen"><div className="loading-logo">FB</div><div className="loading-text">Decrypting FinBoard...</div></div>;
  if (!mode) return <Login />;

  const pages = {
    dashboard: <Dashboard />,
    expenses: <Expenses />,
    team: mode === "admin" ? <Team /> : <Dashboard />,
    payroll: mode === "admin" ? <Payroll /> : <Dashboard />,
    crypto: mode === "admin" ? <Portfolio /> : <Dashboard />,
    prices: <LivePrices />,
    loans: <Loans />,
    audit: mode === "admin" ? <AuditLog /> : <Dashboard />,
    security: mode === "admin" ? <Security /> : <Dashboard />,
    backup: mode === "admin" ? <Backup /> : <Dashboard />,
    payslip: <Payslip />,
    attendance: <Attendance />,
    invoice: mode === "admin" ? <Invoice /> : <Dashboard />,
    analytics: mode === "admin" ? <AnalyticsReports /> : <Dashboard />,
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "var(--bg, #060911)" }}>
      <Sidebar activePage={activePage} setActivePage={setActivePage} mobile={mobile} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Topbar activePage={activePage} setActivePage={setActivePage} mobile={mobile} />
        <div className="content-area" style={{ flex: 1, overflowY: "auto" }}>
          {pages[activePage] || <Dashboard />}
        </div>
      </div>
      <Toast />
    </div>
  );
}

export default function App() {
  return <ErrorBoundary><AppProvider><AppContent /></AppProvider></ErrorBoundary>;
}
